import User from "../../../images/avatar/b-sm.jpg";
import User2 from "../../../images/avatar/c-sm.jpg";
import User3 from "../../../images/avatar/a-sm.jpg";
import User4 from "../../../images/avatar/d-sm.jpg";

export const userData = [
  {
    id: 1,
    avatarBg: "purple",
    name: "Abu Bin Ishtiyak",
    displayName: "Ishtiak",
    dob: "10 Aug, 1980",
    role: "Customer",
    checked: false,
    email: "info@softnio.com",
    balance: "35,040.34",
    phone: "818474958",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "10 Feb 2020",
    status: "Active",
    address: "2337 Kildeer Drive",
    state: "Kentucky",
    country: "Canada",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 2,
    avatarBg: "purple",
    image: User3,
    name: "Ashley Lawson",
    dob: "10 Sept, 1990",
    role: "Investor",
    email: "ashley@softnio.com",
    balance: "580.00",
    checked: false,
    phone: "1243941787",
    emailStatus: "success",
    kycStatus: "pending",
    lastLogin: "07 Feb 2020",
    status: "Pending",
    country: "United States",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 3,
    avatarBg: "info",
    name: "Joe Larson",
    dob: "19 Jan, 1985",
    role: "Customer",
    email: "larson@example.com",
    balance: "32,000.34",
    checked: false,
    phone: "1686032320",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "04 Feb 2020",
    status: "Active",
    country: "England",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 4,
    avatarBg: "danger",
    name: "Jane Montgomery",
    dob: "24 April, 1985",
    role: "Subscriber",
    email: "jane84@example.com",
    balance: "0.00",
    checked: false,
    phone: "4392715360",
    emailStatus: "alert",
    kycStatus: "alert",
    lastLogin: "01 Feb 2020",
    status: "Suspend",
    country: "United States",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 5,
    avatarBg: "purple",
    name: "Frances Burns",
    dob: "30 May, 2000",
    role: "Manager",
    image: User,
    email: "frances@example.com",
    balance: "42.50",
    checked: false,
    phone: "6391303150",
    emailStatus: "pending",
    kycStatus: "error",
    lastLogin: "31 Jan 2020",
    status: "Active",
    country: "Bangladesh",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 6,
    avatarBg: "primary",
    name: "Alan Butler",
    dob: "10 Feb, 1997",
    role: "Investor",
    image: User2,
    email: "butler@example.com",
    balance: "440.34",
    checked: false,
    phone: "9633091706",
    emailStatus: "pending",
    kycStatus: "warning",
    lastLogin: "18 Jan 2020",
    status: "Inactive",
    country: "India",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 7,
    avatarBg: "warning",
    name: "Victoria Lynch",
    dob: "02 May, 1993",
    role: "Investor",
    email: "victoria@example.com",
    balance: "59,400.68",
    checked: false,
    phone: "8119854846",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "15 Jan 2020",
    status: "Active",
    country: "China",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 8,
    avatarBg: "success",
    name: "Patrick Newman",
    dob: "15 Feb, 1997",
    role: "Customer",
    email: "patrick@example.com",
    balance: "30.00",
    checked: false,
    phone: "9422384474",
    emailStatus: "success",
    kycStatus: "pending",
    lastLogin: "08 Jan 2020",
    status: "Active",
    country: "India",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 9,
    avatarBg: "purple",
    name: "Jane Harris",
    dob: "28 Feb, 1985",
    role: "Customer",
    image: User4,
    email: "harris@example.com",
    balance: "5,530.23",
    checked: false,
    phone: "1234472384",
    emailStatus: "pending",
    kycStatus: "pending",
    lastLogin: "02 Jan 2020",
    status: "Pending",
    country: "Vietnam",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 10,
    avatarBg: "purple",
    name: "Emma Walker",
    dob: "30 Dec, 1998",
    role: "Investor",
    email: "walker@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "United States",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 11,
    avatarBg: "pink",
    name: "Lilja Peltola",
    dob: "30 Dec, 1998",
    role: "Investor",
    email: "lilja@example.com",
    balance: "105.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "success",
    kycStatus: "pending",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "Canada",
    designation: "Web Developer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 12,
    avatarBg: "secondary",
    name: "Annette Hunter",
    dob: "30 Dec, 1998",
    role: "Investor",
    email: "hunter@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "25 Dec 2019",
    status: "Pending",
    country: "United States",
    designation: "UI/UX Designer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 13,
    avatarBg: "pink",
    name: "Sara Koivisto",
    dob: "30 Dec, 1998",
    role: "Customer",
    email: "sara@example.com",
    balance: "165.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "rejected",
    kycStatus: "pending",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "Russia",
    designation: "Web Developer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 14,
    avatarBg: "blue",
    name: "Kianna Pham",
    dob: "30 Dec, 1998",
    role: "Admin",
    email: "kiana@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "success",
    kycStatus: "rejected",
    lastLogin: "25 Dec 2019",
    status: "Suspend",
    country: "South Korea",
    designation: "Accountant",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 15,
    avatarBg: "pink",
    name: "Raymond Atkins",
    dob: "30 Dec, 1998",
    role: "Customer",
    image: User4,
    email: "sara@example.com",
    balance: "165.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "rejected",
    kycStatus: "pending",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "Russia",
    designation: "Web Developer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 16,
    avatarBg: "blue",
    name: "Amira Talley",
    dob: "30 Dec, 1998",
    role: "Admin",
    email: "amira@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "pending",
    kycStatus: "rejected",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "Saudi Arabia",
    designation: "Lecturer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 17,
    avatarBg: "secondary",
    name: "Lana Steiner",
    dob: "30 Dec, 1998",
    role: "Admin",
    email: "steinar@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "pending",
    kycStatus: "rejected",
    lastLogin: "25 Dec 2019",
    status: "Pending",
    country: "Latvia",
    designation: "Accountant",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 18,
    avatarBg: "warning",
    name: "Joshua Mcnair",
    dob: "30 Dec, 1998",
    image: User4,
    role: "Admin",
    email: "joshua@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "pending",
    kycStatus: "rejected",
    lastLogin: "25 Dec 2019",
    status: "Suspend",
    country: "Ireland",
    designation: "Web Developer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 19,
    avatarBg: "secondary",
    name: "Asiya Wolff",
    dob: "30 Dec, 1998",
    role: "Customer",
    email: "asia@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "success",
    kycStatus: "success",
    lastLogin: "25 Dec 2019",
    status: "Active",
    country: "Latvia",
    designation: "Accountant",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
  {
    id: 20,
    avatarBg: "warning",
    name: "Fox Mccloud",
    dob: "30 Dec, 1998",
    role: "Admin",
    email: "fox@example.com",
    balance: "55.00",
    checked: false,
    phone: "4634717173",
    emailStatus: "pending",
    kycStatus: "rejected",
    lastLogin: "25 Dec 2019",
    status: "Suspend",
    country: "Ireland",
    designation: "Web Developer",
    projects: "213",
    performed: "87.5",
    tasks: "587",
  },
];

export const notes = [
  {
    id: 1,
    text: "Aproin at metus et dolor tincidunt feugiat eu id quam. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aenean sollicitudin non nunc vel pharetra.",
    date: "November 18, 2019",
    time: "5:34",
    company: "Softnio",
  },
  {
    id: 2,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eleifend libero semper metus aliquam tempus. Sed efficitur elit et ligula lobortis",
    date: "December 27, 2019",
    time: "7:00",
    company: "Softnio",
  },
];

export const filterStatus = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
];
export const ActionStatus = [
  { value: "Pending", label: "Pending" },
  { value: "Processing", label: "Processing" },
  { value: "Completed", label: "Completed" },
];

export const filterRole = [
  { value: "client", label: "Client" },
  { value: "broker", label: "Broker" },
  { value: "medical_partner", label: "Medical Partner" },
  { value: "enterprise", label: "Enterprise" },
  { value: "employee", label: "Employee" },
];

export const countryListOptions = [
  {
    label: "Afghanistan",
    value: "Afghanistan",
    code: "AF",
  },
  {
    label: "Aland Islands",
    value: "Aland Islands",
    code: "AX",
  },
  {
    label: "Albania",
    value: "Albania",
    code: "AL",
  },
  {
    label: "Algeria",
    value: "Algeria",
    code: "DZ",
  },
  {
    label: "AmericanSamoa",
    value: "AmericanSamoa",
    code: "AS",
  },
  {
    label: "Andorra",
    value: "Andorra",
    code: "AD",
  },
  {
    label: "Angola",
    value: "Angola",
    code: "AO",
  },
  {
    label: "Anguilla",
    value: "Anguilla",
    code: "AI",
  },
  {
    label: "Antarctica",
    value: "Antarctica",
    code: "AQ",
  },

  {
    label: "Argentina",
    value: "Argentina",
    code: "AR",
  },
  {
    label: "Armenia",
    value: "Armenia",
    code: "AM",
  },
  {
    label: "Aruba",
    value: "Aruba",
    code: "AW",
  },
  {
    label: "Australia",
    value: "Australia",
    code: "AU",
  },
  {
    label: "Austria",
    value: "Austria",
    code: "AT",
  },
  {
    label: "Azerbaijan",
    value: "Azerbaijan",
    code: "AZ",
  },
  {
    label: "Bahamas",
    value: "Bahamas",
    code: "BS",
  },
  {
    label: "Bahrain",
    value: "Bahrain",
    code: "BH",
  },
  {
    label: "Bangladesh",
    value: "Bangladesh",
    code: "BD",
  },
  {
    label: "Barbados",
    value: "Barbados",
    code: "BB",
  },
  {
    label: "Belarus",
    value: "Belarus",
    code: "BY",
  },
  {
    label: "Belgium",
    value: "Belgium",
    code: "BE",
  },
  {
    label: "Belize",
    value: "Belize",
    code: "BZ",
  },
  {
    label: "Benin",
    value: "Benin",
    code: "BJ",
  },
  {
    label: "Bermuda",
    value: "Bermuda",
    code: "BM",
  },
  {
    label: "Bhutan",
    value: "Bhutan",
    code: "BT",
  },
  {
    label: "Bolivia, Plurinational State of",
    value: "Bolivia",
    code: "BO",
  },
  {
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    code: "BA",
  },
  {
    label: "Botswana",
    value: "Botswana",
    code: "BW",
  },
  {
    label: "Brazil",
    value: "Brazil",
    code: "BR",
  },
  {
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
    code: "IO",
  },
  {
    label: "Brunei Darussalam",
    value: "Brunei Darussalam",
    code: "BN",
  },
  {
    label: "Bulgaria",
    value: "Bulgaria",
    code: "BG",
  },
  {
    label: "Burkina Faso",
    value: "Burkina Faso",
    code: "BF",
  },
  {
    label: "Burundi",
    value: "Burundi",
    code: "BI",
  },
  {
    label: "Cambodia",
    value: "Cambodia",
    code: "KH",
  },
  {
    label: "Cameroon",
    value: "Cameroon",
    code: "CM",
  },
  {
    label: "Canada",
    value: "Canada",
    code: "CA",
  },
  {
    label: "Cape Verde",
    value: "Cape Verde",
    code: "CV",
  },
  {
    label: "Cayman Islands",
    value: "Cayman Islands",
    code: "KY",
  },
  {
    label: "Central African Republic",
    value: "Central African Republic",
    code: "CF",
  },
  {
    label: "Chad",
    value: "Chad",
    code: "TD",
  },
  {
    label: "Chile",
    value: "Chile",
    code: "CL",
  },
  {
    label: "China",
    value: "China",
    code: "CN",
  },
  {
    label: "Christmas Island",
    value: "Christmas Island",
    code: "CX",
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
    code: "CC",
  },
  {
    label: "Colombia",
    value: "Colombia",
    code: "CO",
  },
  {
    label: "Comoros",
    value: "Comoros",
    code: "KM",
  },

  {
    label: "Costa Rica",
    value: "Costa Rica",
    code: "CR",
  },

  {
    label: "Croatia",
    value: "Croatia",
    code: "HR",
  },
  {
    label: "Cuba",
    value: "Cuba",
    code: "CU",
  },
  {
    label: "Cyprus",
    value: "Cyprus",
    code: "CY",
  },
  {
    label: "Czech Republic",
    value: "Czech Republic",
    code: "CZ",
  },
  {
    label: "Denmark",
    value: "Denmark",
    code: "DK",
  },

  {
    label: "Dominica",
    value: "Dominica",
    code: "DM",
  },
  {
    label: "Dominican Republic",
    value: "Dominican Republic",
    code: "DO",
  },
  {
    label: "Ecuador",
    value: "Ecuador",
    code: "EC",
  },
  {
    label: "Egypt",
    value: "Egypt",
    code: "EG",
  },

  {
    label: "Eritrea",
    value: "Eritrea",
    code: "ER",
  },
  {
    label: "Estonia",
    value: "Estonia",
    code: "EE",
  },
  {
    label: "Ethiopia",
    value: "Ethiopia",
    code: "ET",
  },

  {
    label: "Finland",
    value: "Finland",
    code: "FI",
  },
  {
    label: "France",
    value: "France",
    code: "FR",
  },
  {
    label: "French Guiana",
    value: "French Guiana",
    code: "GF",
  },
  {
    label: "French Polynesia",
    value: "French Polynesia",
    code: "PF",
  },
  {
    label: "Gabon",
    value: "Gabon",
    code: "GA",
  },
  {
    label: "Gambia",
    value: "Gambia",
    code: "GM",
  },
  {
    label: "Georgia",
    value: "Georgia",
    code: "GE",
  },
  {
    label: "Germany",
    value: "Germany",
    code: "DE",
  },
  {
    label: "Ghana",
    value: "Ghana",
    code: "GH",
  },
  {
    label: "Gibraltar",
    value: "Gibraltar",
    code: "GI",
  },
  {
    label: "Greece",
    value: "Greece",
    code: "GR",
  },
  {
    label: "Greenland",
    value: "Greenland",
    code: "GL",
  },
  {
    label: "Grenada",
    value: "Grenada",
    code: "GD",
  },
  {
    label: "Guadeloupe",
    value: "Guadeloupe",
    code: "GP",
  },
  {
    label: "Guam",
    value: "Guam",
    code: "GU",
  },
  {
    label: "Guatemala",
    value: "Guatemala",
    code: "GT",
  },
  {
    label: "Guernsey",
    value: "Guernsey",
    code: "GG",
  },

  {
    label: "Holy See (Vatican City State)",
    value: "Holy See (Vatican City State)",
    code: "VA",
  },
  {
    label: "Honduras",
    value: "Honduras",
    code: "HN",
  },
  {
    label: "Hong Kong",
    value: "Hong Kong",
    code: "HK",
  },
  {
    label: "Hungary",
    value: "Hungary",
    code: "HU",
  },
  {
    label: "Iceland",
    value: "Iceland",
    code: "IS",
  },
  {
    label: "India",
    value: "India",
    code: "IN",
  },
  {
    label: "Indonesia",
    value: "Indonesia",
    code: "ID",
  },
  {
    label: "Iran, Islamic Republic of Persian Gulf",
    value: "Iran",
    code: "IR",
  },
  {
    label: "Iraq",
    value: "Iraq",
    code: "IQ",
  },
  {
    label: "Ireland",
    value: "Ireland",
    code: "IE",
  },

  {
    label: "Italy",
    value: "Italy",
    code: "IT",
  },
  {
    label: "Jamaica",
    value: "Jamaica",
    code: "JM",
  },
  {
    label: "Japan",
    value: "Japan",
    code: "JP",
  },
  {
    label: "Jersey",
    value: "Jersey",
    code: "JE",
  },
  {
    label: "Jordan",
    value: "Jordan",
    code: "JO",
  },
  {
    label: "Kazakhstan",
    value: "Kazakhstan",
    code: "KZ",
  },
  {
    label: "Kenya",
    value: "Kenya",
    code: "KE",
  },
  {
    label: "Kiribati",
    value: "Kiribati",
    code: "KI",
  },
  {
    label: "Korea, Democratic People's Republic of Korea",
    value: "Korea",
    code: "KP",
  },
  {
    label: "Korea, Republic of South Korea",
    value: "Korea, Republic of South Korea",
    code: "KR",
  },
  {
    label: "Kuwait",
    value: "Kuwait",
    code: "KW",
  },
  {
    label: "Kyrgyzstan",
    value: "Kyrgyzstan",
    code: "KG",
  },
  {
    label: "Laos",
    value: "Laos",
    code: "LA",
  },
  {
    label: "Latvia",
    value: "Latvia",
    code: "LV",
  },
  {
    label: "Lebanon",
    value: "Lebanon",
    code: "LB",
  },
  {
    label: "Lesotho",
    value: "Lesotho",
    code: "LS",
  },
  {
    label: "Liberia",
    value: "Liberia",
    code: "LR",
  },

  {
    label: "Luxembourg",
    value: "Luxembourg",
    code: "LU",
  },
  {
    label: "Macao",
    value: "Macao",
    code: "MO",
  },
  {
    label: "Macedonia",
    value: "Macedonia",
    code: "MK",
  },
  {
    label: "Madagascar",
    value: "Madagascar",
    code: "MG",
  },
  {
    label: "Malawi",
    value: "Malawi",
    code: "MW",
  },
  {
    label: "Malaysia",
    value: "Malaysia",
    code: "MY",
  },
  {
    label: "Maldives",
    value: "Maldives",
    code: "MV",
  },
  {
    label: "Mali",
    value: "Mali",
    code: "ML",
  },
  {
    label: "Malta",
    value: "Malta",
    code: "MT",
  },

  {
    label: "Mexico",
    value: "Mexico",
    code: "MX",
  },

  {
    label: "Moldova",
    value: "Moldova",
    code: "MD",
  },
  {
    label: "Monaco",
    value: "Monaco",
    code: "MC",
  },
  {
    label: "Mongolia",
    value: "Mongolia",
    code: "MN",
  },
  {
    label: "Montenegro",
    value: "Montenegro",
    code: "ME",
  },
  {
    label: "Montserrat",
    value: "Montserrat",
    code: "MS",
  },
  {
    label: "Morocco",
    value: "Morocco",
    code: "MA",
  },
  {
    label: "Mozambique",
    value: "Mozambique",
    code: "MZ",
  },
  {
    label: "Myanmar",
    value: "Myanmar",
    code: "MM",
  },
  {
    label: "Namibia",
    value: "Namibia",
    code: "NA",
  },
  {
    label: "Nauru",
    value: "Nauru",
    code: "NR",
  },
  {
    label: "Nepal",
    value: "Nepal",
    code: "NP",
  },
  {
    label: "Netherlands",
    value: "Netherlands",
    code: "NL",
  },

  {
    label: "New Zealand",
    value: "New Zealand",
    code: "NZ",
  },

  {
    label: "Nigeria",
    value: "Nigeria",
    code: "NG",
  },
  {
    label: "Niue",
    value: "Niue",
    code: "NU",
  },

  {
    label: "Norway",
    value: "Norway",
    code: "NO",
  },
  {
    label: "Oman",
    value: "Oman",
    code: "OM",
  },
  {
    label: "Pakistan",
    value: "Pakistan",
    code: "PK",
  },
  {
    label: "Palau",
    value: "Palau",
    code: "PW",
  },
  {
    label: "Palestinian Territory, Occupied",
    value: "Palestinian Territory, Occupied",
    code: "PS",
  },
  {
    label: "Panama",
    value: "Panama",
    code: "PA",
  },
  {
    label: "Papua New Guinea",
    value: "Papua New Guinea",
    code: "PG",
  },
  {
    label: "Paraguay",
    value: "Paraguay",
    code: "PY",
  },
  {
    label: "Peru",
    value: "Peru",
    code: "PE",
  },
  {
    label: "Philippines",
    value: "Philippines",
    code: "PH",
  },
  {
    label: "Pitcairn",
    value: "Pitcairn",
    code: "PN",
  },
  {
    label: "Poland",
    value: "Poland",
    code: "PL",
  },
  {
    label: "Portugal",
    value: "Portugal",
    code: "PT",
  },
  {
    label: "Puerto Rico",
    value: "Puerto Rico",
    code: "PR",
  },
  {
    label: "Qatar",
    value: "Qatar",
    code: "QA",
  },
  {
    label: "Romania",
    value: "Romania",
    code: "RO",
  },
  {
    label: "Russia",
    value: "Russia",
    code: "RU",
  },
  {
    label: "Rwanda",
    value: "Rwanda",
    code: "RW",
  },
  {
    label: "Reunion",
    value: "Reunion",
    code: "RE",
  },

  {
    label: "Saudi Arabia",
    value: "Saudi Arabia",
    code: "SA",
  },
  {
    label: "Senegal",
    value: "Senegal",
    code: "SN",
  },
  {
    label: "Serbia",
    value: "Serbia",
    code: "RS",
  },
  {
    label: "Singapore",
    value: "Singapore",
    code: "SG",
  },
  {
    label: "Slovakia",
    value: "Slovakia",
    code: "SK",
  },
  {
    label: "Slovenia",
    value: "Slovenia",
    code: "SI",
  },
  {
    label: "Solomon Islands",
    value: "Solomon Islands",
    code: "SB",
  },
  {
    label: "Somalia",
    value: "Somalia",
    code: "SO",
  },
  {
    label: "South Africa",
    value: "South Africa",
    code: "ZA",
  },
  {
    label: "South Sudan",
    value: "South Sudan",
    code: "SS",
  },

  {
    label: "Spain",
    value: "Spain",
    code: "ES",
  },
  {
    label: "Sri Lanka",
    value: "Sri Lanka",
    code: "LK",
  },
  {
    label: "Sudan",
    value: "Sudan",
    code: "SD",
  },

  {
    label: "Swaziland",
    value: "Swaziland",
    code: "SZ",
  },
  {
    label: "Sweden",
    value: "Sweden",
    code: "SE",
  },
  {
    label: "Switzerland",
    value: "Switzerland",
    code: "CH",
  },
  {
    label: "Syrian Arab Republic",
    value: "Syrian Arab Republic",
    code: "SY",
  },
  {
    label: "Taiwan",
    value: "Taiwan",
    code: "TW",
  },
  {
    label: "Tajikistan",
    value: "Tajikistan",
    code: "TJ",
  },
  {
    label: "Tanzania, United Republic of Tanzania",
    value: "Tanzania",
    code: "TZ",
  },
  {
    label: "Thailand",
    value: "Thailand",
    code: "TH",
  },
  {
    label: "Tunisia",
    value: "Tunisia",
    code: "TN",
  },
  {
    label: "Turkey",
    value: "Turkey",
    code: "TR",
  },
  {
    label: "Turkmenistan",
    value: "Turkmenistan",
    code: "TM",
  },
  {
    label: "Turks and Caicos Islands",
    value: "Turks",
    code: "TC",
  },
  {
    label: "Tuvalu",
    value: "Tuvalu",
    code: "TV",
  },
  {
    label: "Uganda",
    value: "Uganda",
    code: "UG",
  },
  {
    label: "Ukraine",
    value: "Ukraine",
    code: "UA",
  },
  {
    label: "United Arab Emirates",
    value: "United Arab Emirates",
    code: "AE",
  },
  {
    label: "United Kingdom",
    value: "United Kingdom",
    code: "GB",
  },
  {
    label: "United States",
    value: "United States",
    code: "US",
  },
  {
    label: "Uruguay",
    value: "Uruguay",
    code: "UY",
  },
  {
    label: "Uzbekistan",
    value: "Uzbekistan",
    code: "UZ",
  },
  {
    label: "Vanuatu",
    value: "Vanuatu",
    code: "VU",
  },
  {
    label: "Venezuela, Bolivarian Republic of Venezuela",
    value: "Venezuela",
    code: "VE",
  },
  {
    label: "Vietnam",
    value: "Vietnam",
    code: "VN",
  },
  {
    label: "Virgin Islands, British",
    value: "Virgin Islands, British",
    code: "VG",
  },
  {
    label: "Virgin Islands, U.S.",
    value: "Virgin Islands, U.S.",
    code: "VI",
  },
  {
    label: "Wallis and Futuna",
    value: "Wallis and Futuna",
    code: "WF",
  },
  {
    label: "Yemen",
    value: "Yemen",
    code: "YE",
  },
  {
    label: "Zambia",
    value: "Zambia",
    code: "ZM",
  },
  {
    label: "Zimbabwe",
    value: "Zimbabwe",
    code: "ZW",
  },
];

export const countryOptions = [
  {
    label: "Afghanistan(+93)",
    value: "+93",
    code: "AF",
  },
  {
    label: "Aland Islands",
    value: "+358",
    code: "AX",
  },
  {
    label: "Albania",
    value: "+355",
    code: "AL",
  },
  {
    label: "Algeria",
    value: "+213",
    code: "DZ",
  },
  {
    label: "AmericanSamoa",
    value: "+1684",
    code: "AS",
  },
  {
    label: "Andorra",
    value: "+376",
    code: "AD",
  },
  {
    label: "Angola",
    value: "+244",
    code: "AO",
  },
  {
    label: "Anguilla",
    value: "+1264",
    code: "AI",
  },
  {
    label: "Antarctica",
    value: "+672",
    code: "AQ",
  },
  {
    label: "Antigua and Barbuda",
    value: "+1268",
    code: "AG",
  },
  {
    label: "Argentina",
    value: "+54",
    code: "AR",
  },
  {
    label: "Armenia",
    value: "+374",
    code: "AM",
  },
  {
    label: "Aruba",
    value: "+297",
    code: "AW",
  },
  {
    label: "Australia",
    value: "+61",
    code: "AU",
  },
  {
    label: "Austria",
    value: "+43",
    code: "AT",
  },
  {
    label: "Azerbaijan",
    value: "+994",
    code: "AZ",
  },
  {
    label: "Bahamas",
    value: "+1242",
    code: "BS",
  },
  {
    label: "Bahrain",
    value: "+973",
    code: "BH",
  },
  {
    label: "Bangladesh",
    value: "+880",
    code: "BD",
  },
  {
    label: "Barbados",
    value: "+1246",
    code: "BB",
  },
  {
    label: "Belarus",
    value: "+375",
    code: "BY",
  },
  {
    label: "Belgium",
    value: "+32",
    code: "BE",
  },
  {
    label: "Belize",
    value: "+501",
    code: "BZ",
  },
  {
    label: "Benin",
    value: "+229",
    code: "BJ",
  },
  {
    label: "Bermuda",
    value: "+1441",
    code: "BM",
  },
  {
    label: "Bhutan",
    value: "+975",
    code: "BT",
  },
  {
    label: "Bolivia, Plurinational State of",
    value: "+591",
    code: "BO",
  },
  {
    label: "Bosnia and Herzegovina",
    value: "+387",
    code: "BA",
  },
  {
    label: "Botswana",
    value: "+267",
    code: "BW",
  },
  {
    label: "Brazil",
    value: "+55",
    code: "BR",
  },
  {
    label: "British Indian Ocean Territory",
    value: "+246",
    code: "IO",
  },
  {
    label: "Brunei Darussalam",
    value: "+673",
    code: "BN",
  },
  {
    label: "Bulgaria",
    value: "+359",
    code: "BG",
  },
  {
    label: "Burkina Faso",
    value: "+226",
    code: "BF",
  },
  {
    label: "Burundi",
    value: "+257",
    code: "BI",
  },
  {
    label: "Cambodia",
    value: "+855",
    code: "KH",
  },
  {
    label: "Cameroon",
    value: "+237",
    code: "CM",
  },
  {
    label: "Canada",
    value: "+1",
    code: "CA",
  },
  {
    label: "Cape Verde",
    value: "+238",
    code: "CV",
  },
  {
    label: "Cayman Islands",
    value: "+ 345",
    code: "KY",
  },
  {
    label: "Central African Republic",
    value: "+236",
    code: "CF",
  },
  {
    label: "Chad",
    value: "+235",
    code: "TD",
  },
  {
    label: "Chile",
    value: "+56",
    code: "CL",
  },
  {
    label: "China",
    value: "+86",
    code: "CN",
  },
  {
    label: "Christmas Island",
    value: "+61",
    code: "CX",
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "+61",
    code: "CC",
  },
  {
    label: "Colombia",
    value: "+57",
    code: "CO",
  },
  {
    label: "Comoros",
    value: "+269",
    code: "KM",
  },
  {
    label: "Congo",
    value: "+242",
    code: "CG",
  },
  {
    label: "Congo, The Democratic Republic of the Congo",
    value: "+243",
    code: "CD",
  },
  {
    label: "Cook Islands",
    value: "+682",
    code: "CK",
  },
  {
    label: "Costa Rica",
    value: "+506",
    code: "CR",
  },
  {
    label: "Cote d'Ivoire",
    value: "+225",
    code: "CI",
  },
  {
    label: "Croatia",
    value: "+385",
    code: "HR",
  },
  {
    label: "Cuba",
    value: "+53",
    code: "CU",
  },
  {
    label: "Cyprus",
    value: "+357",
    code: "CY",
  },
  {
    label: "Czech Republic",
    value: "+420",
    code: "CZ",
  },
  {
    label: "Denmark",
    value: "+45",
    code: "DK",
  },
  {
    label: "Djibouti",
    value: "+253",
    code: "DJ",
  },
  {
    label: "Dominica",
    value: "+1767",
    code: "DM",
  },
  {
    label: "Dominican Republic",
    value: "+1849",
    code: "DO",
  },
  {
    label: "Ecuador",
    value: "+593",
    code: "EC",
  },
  {
    label: "Egypt",
    value: "+20",
    code: "EG",
  },
  {
    label: "El Salvador",
    value: "+503",
    code: "SV",
  },
  {
    label: "Equatorial Guinea",
    value: "+240",
    code: "GQ",
  },
  {
    label: "Eritrea",
    value: "+291",
    code: "ER",
  },
  {
    label: "Estonia",
    value: "+372",
    code: "EE",
  },
  {
    label: "Ethiopia",
    value: "+251",
    code: "ET",
  },
  {
    label: "Falkland Islands (Malvinas)",
    value: "+500",
    code: "FK",
  },
  {
    label: "Faroe Islands",
    value: "+298",
    code: "FO",
  },
  {
    label: "Fiji",
    value: "+679",
    code: "FJ",
  },
  {
    label: "Finland",
    value: "+358",
    code: "FI",
  },
  {
    label: "France",
    value: "+33",
    code: "FR",
  },
  {
    label: "French Guiana",
    value: "+594",
    code: "GF",
  },
  {
    label: "French Polynesia",
    value: "+689",
    code: "PF",
  },
  {
    label: "Gabon",
    value: "+241",
    code: "GA",
  },
  {
    label: "Gambia",
    value: "+220",
    code: "GM",
  },
  {
    label: "Georgia",
    value: "+995",
    code: "GE",
  },
  {
    label: "Germany",
    value: "+49",
    code: "DE",
  },
  {
    label: "Ghana",
    value: "+233",
    code: "GH",
  },
  {
    label: "Gibraltar",
    value: "+350",
    code: "GI",
  },
  {
    label: "Greece",
    value: "+30",
    code: "GR",
  },
  {
    label: "Greenland",
    value: "+299",
    code: "GL",
  },
  {
    label: "Grenada",
    value: "+1473",
    code: "GD",
  },
  {
    label: "Guadeloupe",
    value: "+590",
    code: "GP",
  },
  {
    label: "Guam",
    value: "+1671",
    code: "GU",
  },
  {
    label: "Guatemala",
    value: "+502",
    code: "GT",
  },
  {
    label: "Guernsey",
    value: "+44",
    code: "GG",
  },
  {
    label: "Guinea",
    value: "+224",
    code: "GN",
  },
  {
    label: "Guinea-Bissau",
    value: "+245",
    code: "GW",
  },
  {
    label: "Guyana",
    value: "+595",
    code: "GY",
  },
  {
    label: "Haiti",
    value: "+509",
    code: "HT",
  },
  {
    label: "Holy See (Vatican City State)",
    value: "+379",
    code: "VA",
  },
  {
    label: "Honduras",
    value: "+504",
    code: "HN",
  },
  {
    label: "Hong Kong",
    value: "+852",
    code: "HK",
  },
  {
    label: "Hungary",
    value: "+36",
    code: "HU",
  },
  {
    label: "Iceland",
    value: "+354",
    code: "IS",
  },
  {
    label: "India",
    value: "+91",
    code: "IN",
  },
  {
    label: "Indonesia",
    value: "+62",
    code: "ID",
  },
  {
    label: "Iran, Islamic Republic of Persian Gulf",
    value: "+98",
    code: "IR",
  },
  {
    label: "Iraq",
    value: "+964",
    code: "IQ",
  },
  {
    label: "Ireland",
    value: "+353",
    code: "IE",
  },
  {
    label: "Isle of Man",
    value: "+44",
    code: "IM",
  },
  {
    label: "Israel",
    value: "+972",
    code: "IL",
  },
  {
    label: "Italy",
    value: "+39",
    code: "IT",
  },
  {
    label: "Jamaica",
    value: "+1876",
    code: "JM",
  },
  {
    label: "Japan",
    value: "+81",
    code: "JP",
  },
  {
    label: "Jersey",
    value: "+44",
    code: "JE",
  },
  {
    label: "Jordan",
    value: "+962",
    code: "JO",
  },
  {
    label: "Kazakhstan",
    value: "+77",
    code: "KZ",
  },
  {
    label: "Kenya",
    value: "+254",
    code: "KE",
  },
  {
    label: "Kiribati",
    value: "+686",
    code: "KI",
  },
  {
    label: "Korea, Democratic People's Republic of Korea",
    value: "+850",
    code: "KP",
  },
  {
    label: "Korea, Republic of South Korea",
    value: "+82",
    code: "KR",
  },
  {
    label: "Kuwait",
    value: "+965",
    code: "KW",
  },
  {
    label: "Kyrgyzstan",
    value: "+996",
    code: "KG",
  },
  {
    label: "Laos",
    value: "+856",
    code: "LA",
  },
  {
    label: "Latvia",
    value: "+371",
    code: "LV",
  },
  {
    label: "Lebanon",
    value: "+961",
    code: "LB",
  },
  {
    label: "Lesotho",
    value: "+266",
    code: "LS",
  },
  {
    label: "Liberia",
    value: "+231",
    code: "LR",
  },
  {
    label: "Libyan Arab Jamahiriya",
    value: "+218",
    code: "LY",
  },
  {
    label: "Liechtenstein",
    value: "+423",
    code: "LI",
  },
  {
    label: "Lithuania",
    value: "+370",
    code: "LT",
  },
  {
    label: "Luxembourg",
    value: "+352",
    code: "LU",
  },
  {
    label: "Macao",
    value: "+853",
    code: "MO",
  },
  {
    label: "Macedonia",
    value: "+389",
    code: "MK",
  },
  {
    label: "Madagascar",
    value: "+261",
    code: "MG",
  },
  {
    label: "Malawi",
    value: "+265",
    code: "MW",
  },
  {
    label: "Malaysia",
    value: "+60",
    code: "MY",
  },
  {
    label: "Maldives",
    value: "+960",
    code: "MV",
  },
  {
    label: "Mali",
    value: "+223",
    code: "ML",
  },
  {
    label: "Malta",
    value: "+356",
    code: "MT",
  },
  {
    label: "Marshall Islands",
    value: "+692",
    code: "MH",
  },
  {
    label: "Martinique",
    value: "+596",
    code: "MQ",
  },
  {
    label: "Mauritania",
    value: "+222",
    code: "MR",
  },
  {
    label: "Mauritius",
    value: "+230",
    code: "MU",
  },
  {
    label: "Mayotte",
    value: "+262",
    code: "YT",
  },
  {
    label: "Mexico",
    value: "+52",
    code: "MX",
  },
  {
    label: "Micronesia, Federated States of Micronesia",
    value: "+691",
    code: "FM",
  },
  {
    label: "Moldova",
    value: "+373",
    code: "MD",
  },
  {
    label: "Monaco",
    value: "+377",
    code: "MC",
  },
  {
    label: "Mongolia",
    value: "+976",
    code: "MN",
  },
  {
    label: "Montenegro",
    value: "+382",
    code: "ME",
  },
  {
    label: "Montserrat",
    value: "+1664",
    code: "MS",
  },
  {
    label: "Morocco",
    value: "+212",
    code: "MA",
  },
  {
    label: "Mozambique",
    value: "+258",
    code: "MZ",
  },
  {
    label: "Myanmar",
    value: "+95",
    code: "MM",
  },
  {
    label: "Namibia",
    value: "+264",
    code: "NA",
  },
  {
    label: "Nauru",
    value: "+674",
    code: "NR",
  },
  {
    label: "Nepal",
    value: "+977",
    code: "NP",
  },
  {
    label: "Netherlands",
    value: "+31",
    code: "NL",
  },
  {
    label: "Netherlands Antilles",
    value: "+599",
    code: "AN",
  },
  {
    label: "New Caledonia",
    value: "+687",
    code: "NC",
  },
  {
    label: "New Zealand",
    value: "+64",
    code: "NZ",
  },
  {
    label: "Nicaragua",
    value: "+505",
    code: "NI",
  },
  {
    label: "Niger",
    value: "+227",
    code: "NE",
  },
  {
    label: "Nigeria",
    value: "+234",
    code: "NG",
  },
  {
    label: "Niue",
    value: "+683",
    code: "NU",
  },
  {
    label: "Norfolk Island",
    value: "+672",
    code: "NF",
  },
  {
    label: "Northern Mariana Islands",
    value: "+1670",
    code: "MP",
  },
  {
    label: "Norway",
    value: "+47",
    code: "NO",
  },
  {
    label: "Oman",
    value: "+968",
    code: "OM",
  },
  {
    label: "Pakistan",
    value: "+92",
    code: "PK",
  },
  {
    label: "Palau",
    value: "+680",
    code: "PW",
  },
  {
    label: "Palestinian Territory, Occupied",
    value: "+970",
    code: "PS",
  },
  {
    label: "Panama",
    value: "+507",
    code: "PA",
  },
  {
    label: "Papua New Guinea",
    value: "+675",
    code: "PG",
  },
  {
    label: "Paraguay",
    value: "+595",
    code: "PY",
  },
  {
    label: "Peru",
    value: "+51",
    code: "PE",
  },
  {
    label: "Philippines",
    value: "+63",
    code: "PH",
  },
  {
    label: "Pitcairn",
    value: "+872",
    code: "PN",
  },
  {
    label: "Poland",
    value: "+48",
    code: "PL",
  },
  {
    label: "Portugal",
    value: "+351",
    code: "PT",
  },
  {
    label: "Puerto Rico",
    value: "+1939",
    code: "PR",
  },
  {
    label: "Qatar",
    value: "+974",
    code: "QA",
  },
  {
    label: "Romania",
    value: "+40",
    code: "RO",
  },
  {
    label: "Russia",
    value: "+7",
    code: "RU",
  },
  {
    label: "Rwanda",
    value: "+250",
    code: "RW",
  },
  {
    label: "Reunion",
    value: "+262",
    code: "RE",
  },
  {
    label: "Saint Barthelemy",
    value: "+590",
    code: "BL",
  },
  {
    label: "Saint Helena, Ascension and Tristan Da Cunha",
    value: "+290",
    code: "SH",
  },
  {
    label: "Saint Kitts and Nevis",
    value: "+1869",
    code: "KN",
  },
  {
    label: "Saint Lucia",
    value: "+1758",
    code: "LC",
  },
  {
    label: "Saint Martin",
    value: "+590",
    code: "MF",
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "+508",
    code: "PM",
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "+1784",
    code: "VC",
  },
  {
    label: "Samoa",
    value: "+685",
    code: "WS",
  },
  {
    label: "San Marino",
    value: "+378",
    code: "SM",
  },
  {
    label: "Sao Tome and Principe",
    value: "+239",
    code: "ST",
  },
  {
    label: "Saudi Arabia",
    value: "+966",
    code: "SA",
  },
  {
    label: "Senegal",
    value: "+221",
    code: "SN",
  },
  {
    label: "Serbia",
    value: "+381",
    code: "RS",
  },
  {
    label: "Seychelles",
    value: "+248",
    code: "SC",
  },
  {
    label: "Sierra Leone",
    value: "+232",
    code: "SL",
  },
  {
    label: "Singapore",
    value: "+65",
    code: "SG",
  },
  {
    label: "Slovakia",
    value: "+421",
    code: "SK",
  },
  {
    label: "Slovenia",
    value: "+386",
    code: "SI",
  },
  {
    label: "Solomon Islands",
    value: "+677",
    code: "SB",
  },
  {
    label: "Somalia",
    value: "+252",
    code: "SO",
  },
  {
    label: "South Africa",
    value: "+27",
    code: "ZA",
  },
  {
    label: "South Sudan",
    value: "+211",
    code: "SS",
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "+500",
    code: "GS",
  },
  {
    label: "Spain",
    value: "+34",
    code: "ES",
  },
  {
    label: "Sri Lanka",
    value: "+94",
    code: "LK",
  },
  {
    label: "Sudan",
    value: "+249",
    code: "SD",
  },
  {
    label: "Surilabel",
    value: "+597",
    code: "SR",
  },
  {
    label: "Svalbard and Jan Mayen",
    value: "+47",
    code: "SJ",
  },
  {
    label: "Swaziland",
    value: "+268",
    code: "SZ",
  },
  {
    label: "Sweden",
    value: "+46",
    code: "SE",
  },
  {
    label: "Switzerland",
    value: "+41",
    code: "CH",
  },
  {
    label: "Syrian Arab Republic",
    value: "+963",
    code: "SY",
  },
  {
    label: "Taiwan",
    value: "+886",
    code: "TW",
  },
  {
    label: "Tajikistan",
    value: "+992",
    code: "TJ",
  },
  {
    label: "Tanzania, United Republic of Tanzania",
    value: "+255",
    code: "TZ",
  },
  {
    label: "Thailand",
    value: "+66",
    code: "TH",
  },
  {
    label: "Timor-Leste",
    value: "+670",
    code: "TL",
  },
  {
    label: "Togo",
    value: "+228",
    code: "TG",
  },
  {
    label: "Tokelau",
    value: "+690",
    code: "TK",
  },
  {
    label: "Tonga",
    value: "+676",
    code: "TO",
  },
  {
    label: "Trinidad and Tobago",
    value: "+1868",
    code: "TT",
  },
  {
    label: "Tunisia",
    value: "+216",
    code: "TN",
  },
  {
    label: "Turkey",
    value: "+90",
    code: "TR",
  },
  {
    label: "Turkmenistan",
    value: "+993",
    code: "TM",
  },
  {
    label: "Turks and Caicos Islands",
    value: "+1649",
    code: "TC",
  },
  {
    label: "Tuvalu",
    value: "+688",
    code: "TV",
  },
  {
    label: "Uganda",
    value: "+256",
    code: "UG",
  },
  {
    label: "Ukraine",
    value: "+380",
    code: "UA",
  },
  {
    label: "United Arab Emirates",
    value: "+971",
    code: "AE",
  },
  {
    label: "United Kingdom",
    value: "+44",
    code: "GB",
  },
  {
    label: "United States",
    value: "+1",
    code: "US",
  },
  {
    label: "Uruguay",
    value: "+598",
    code: "UY",
  },
  {
    label: "Uzbekistan",
    value: "+998",
    code: "UZ",
  },
  {
    label: "Vanuatu",
    value: "+678",
    code: "VU",
  },
  {
    label: "Venezuela, Bolivarian Republic of Venezuela",
    value: "+58",
    code: "VE",
  },
  {
    label: "Vietnam",
    value: "+84",
    code: "VN",
  },
  {
    label: "Virgin Islands, British",
    value: "+1284",
    code: "VG",
  },
  {
    label: "Virgin Islands, U.S.",
    value: "+1340",
    code: "VI",
  },
  {
    label: "Wallis and Futuna",
    value: "+681",
    code: "WF",
  },
  {
    label: "Yemen",
    value: "+967",
    code: "YE",
  },
  {
    label: "Zambia",
    value: "+260",
    code: "ZM",
  },
  {
    label: "Zimbabwe",
    value: "+263",
    code: "ZW",
  },
];
